
import {Component, Vue} from "vue-property-decorator";
import {ICar} from "@/modules/Car/interfaces/car.interface";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {ICarList} from "@/modules/CarList/interfaces/car-list.interface";
import {IAppState} from "@/interfaces/app-state.interface";

@Component({})
export default class BaseFormInfoField extends Vue {
  displayGuestPopover = false;

  get storeState(): IAppState { return this.$store.state; }
  get formModel(): ICar.IEntity { return this.storeState.car.formData.formModel; }
  get startForm(): ICar.IEntity { return this.storeState.car.formData.startForm; }

  get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
  get viewMode() { return !this.userAccess.scCarMk; }

  get modelValue() { return this.formModel.guestFlag; }
  set modelValue(value) {
    this.$store.commit('car/setFormProperty', {
      formName: 'formModel',
      name: 'guestFlag',
      value
    });
  };

  mounted() {
    let countPopoverDisplay = JSON.parse(localStorage.getItem(ICarList.LocalStorageKeys.DisplayGuestInfoPopover)) || 1;
    if (countPopoverDisplay <= 3) {
      this.displayGuestPopover = true;
      localStorage.setItem(ICarList.LocalStorageKeys.DisplayGuestInfoPopover, JSON.stringify(countPopoverDisplay + 1));
      setTimeout(() => this.displayGuestPopover = false, 5000);
    }
  }

  changeGuestFlag(value) {
    if (value) {
      if (!this.formModel.payGuestHours) {
        this.$store.commit('car/setFormProperty', {
          formName: 'formModel',
          name: 'payGuestHours',
          value: this.userAccess.payGuestHours,
        });
      }
    }
    this.$emit('formItemChange');
  }
}
